export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Edit.vue?vue&type=template&id=2baf8d20"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customers/Edit.vue?vue&type=template&id=2baf8d20
// module id = 2554
// module chunks = 31